import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useRemoveBranches = () => {
  const { dispatch } = useCampaignEditorContext();

  return useCallback(() => {
    dispatch({
      type: 'REMOVE_BRANCHES',
    });
  }, [dispatch]);
};
